import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ help, ...args }) {
    super(args)
    const child = this.getComponentWithVModel('json-editor')
    this.children = [child]
    if (help) {
      this.children.push({
        component: 'el-alert',
        attrs: {
          showIcon: true,
          closable: false,
          title: help
        }
      })
    }
  }
}
